import dynamic from 'next/dynamic';
import { useContext, useEffect, useState } from 'react';

import HeaderFooterContext from '@/context/HeaderFooterContext';
import StoreDataContext from '@/context/StoreDataContext';
import { useBreakPoints } from '@/utils/useBreakPoints';

const FilterLocator = dynamic(() => import('./filter-locator'));
const MapComponent = dynamic(() => import('./map-component'));
const SearchLocator = dynamic(() => import('./search-locator'));
const LocationListWithOrderBy = dynamic(
  () => import('./location-list-with-orderby')
);

const StoreLocatorComponent = (props: any) => {
  // tablet mobile change key
  const [expandMap, setExpandmap] = useState(false);
  const [showList, setShowList] = useState(false); // toggle Store Locator page view between locations and map on tablet and mobile screen (true: locations, false: map)
  const applyFilter = useContext(StoreDataContext);
  const storeData = useContext(StoreDataContext);
  const locations = applyFilter.applyFilters;
  const values = useContext(HeaderFooterContext);
  const isDesktop = useBreakPoints();
  const [preFilterData, setPreFilterData] = useState(
    props?.preFilter?.data?.attributes?.Filter
  );
  const keys: any = {
    driveup: false,
    heated: false,
    climateControlled: false,
    small: false,
    medium: false,
    large: false,
    xlarge: false,
    carstorage: false,
    parking: false,
  };
  const handleExpand = (expand: any) => {
    setExpandmap(expand);
  };

  const setAndresetpreFilters = (value: any) => {
    if (props?.preFilter?.data !== null && props?.vehicle) {
      if (preFilterData === 'Car Storage') {
        keys.carstorage = value;
        storeData.setFilterData(keys);
      } else if (preFilterData === 'Drive-up') {
        keys.driveup = value;
        storeData.setFilterData(keys);
      } else if (preFilterData === 'Heated') {
        keys.heated = value;
        storeData.setFilterData(keys);
      } else if (preFilterData === 'Outdoor Parking') {
        keys.parking = value;
        storeData.setFilterData(keys);
      } else if (preFilterData === 'Climate Controlled') {
        keys.climateControlled = value;
        storeData.setFilterData(keys);
      }
    }
  };

  useEffect(() => {
    values?.setShowFooter(false);
    setShowList(false);
    setAndresetpreFilters(true);
  }, []);
  useEffect(() => {
    if (storeData?.facilityc?.length) {
      const slug = props?.cityLanding;
      const quickSearchData =
        storeData &&
        storeData.facilityc &&
        storeData.facilityc.find(
          (item: { city: string }) => item.city === slug
        );
      storeData.setquickSearchInfo(quickSearchData);
    }
    if (storeData?.resetpreFilters && preFilterData) {
      Object.assign(keys, storeData?.filterData);
      setPreFilterData('');
    }
  }, [storeData?.storeData, storeData?.facilityc]);
  return (
    <>
      <div
        id="self-storage"
        className={
          values?.isShowSelfHeader
            ? 'find-storage-wrapper no-units-found-wrapper sv-page-content'
            : 'find-storage-wrapper no-units-found-wrapper sv-page-content pt-0 mt-0 fullview-map'
        }
      >
        <div
          className={expandMap ? 'custom-section' : 'container custom-section'}
        >
          <section className="sv-find-storage-web">
            <div className="row g-0">
              {/* Desktop (Two column layout) - show search input field and filters */}
              {isDesktop && !expandMap && (
                <div className="col-lg-7">
                  <div className="sv-find-storage-content">
                    <SearchLocator
                      cityTitle={props?.cityTitle}
                      vehicle={props?.vehicleLandingPage}
                    ></SearchLocator>
                    <FilterLocator
                      expandMap={expandMap}
                      cityLanding={props.cityLanding}
                    ></FilterLocator>
                  </div>
                </div>
              )}

              <div
                className={`${
                  expandMap ? 'col-lg-12 fullScreen-map' : 'col-lg-5'
                } col-md-12 col-12`}
              >
                <div
                  className={
                    values?.isShowSelfHeader
                      ? 'view-units-map'
                      : 'view-units-map pt-0'
                  }
                >
                  <div className="tab-view-search-section d-block d-lg-none">
                    {/* Tablet & not expand Map */}
                    {!(isDesktop && !expandMap) && (
                      <>
                        {values?.isShowSelfHeader ? (
                          <>
                            <SearchLocator
                              cityTitle={props.cityTitle}
                              vehicle={props?.vehicleLandingPage}
                            ></SearchLocator>
                            <div className="container px-custom">
                              <div className="sv-multi-select-tabs mb-2">
                                <FilterLocator
                                  expandMap={expandMap}
                                  cityLanding={props.cityLanding}
                                ></FilterLocator>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </>
                    )}
                  </div>
                  <MapComponent
                    locations={locations}
                    handleExpand={handleExpand}
                    cityLanding={props.cityLanding}
                    toggleShow={() => {
                      setShowList(!showList);
                    }}
                    showList={showList}
                  ></MapComponent>
                  {!isDesktop && (
                    <LocationListWithOrderBy
                      locations={locations}
                      toggleShow={() => setShowList(!showList)}
                      showList={showList}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default StoreLocatorComponent;
